import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { ThemeMode } from '../../state/integration-tester.models';

@Component({
  selector: 'it-topbar',
  standalone: true,
  templateUrl: './it-topbar.component.html',
  styleUrls: ['./it-topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf],
})
export class ItTopbarComponent {
  @Input() theme: ThemeMode | null = 'dark';
  @Input() integrationCrumb = 'Integration';
  @Input() requestName = 'Request';

  @Output() toggleTheme = new EventEmitter<void>();
  @Output() startTour = new EventEmitter<void>();
}
